import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    SelectField
} from 'react-admin';
import { useActiveStatus } from "../../defaults/defaults";

const employeeFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Name" source="name" name="name" />,
    <TextInput label="Company id" source="company" name="company" />,
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminEmployeeList = () => {
    const activeStatuses = useActiveStatus();
    return (
        <List
            actions={ <ListActions/> }
            filters={ employeeFilters }>
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id"/>
                <TextField source="name" />
                <SelectField
                    source="status"
                    choices={ activeStatuses }
                />
                <ReferenceField
                    source="company"
                    reference="companies"
                    link="edit"
                >
                    <TextField source="name"/>
                </ReferenceField>
                <>
                    <ShowButton/>
                    <EditButton/>
                </>
            </Datagrid>
        </List>
    );
}